<script lang="ts">
export default {
    data() {
        const router = useRouter()
        return {
            router,
        }
    },
    computed: {
        route() {
            return this.router.currentRoute
        },
        // Computed property that builds the breadcrumb list from the current route
        crumbs() {
            const path = this.filterPath
            const config = useRuntimeConfig()
            const appSlug = config.public?.app_slug
            // Split the path into segments, ignoring leading slash
            const params = path.startsWith('/')
                ? path.substring(1).split('/')
                : path.split('/')

            let crumbs = []
            let breadcrumbPath = ''

            params.forEach((param) => {
                if (appSlug !== 'voirie')
                    param = param.replace(/-/g, '') // remove dashes from each segment (e.g., "form-new" → "formnew")

                breadcrumbPath += `/${param}` // progressively build the path for each crumb
                crumbs.push({ title: param, path: breadcrumbPath }) // push a breadcrumb entry
            })

            // Add a static homepage entry at the beginning
            crumbs.unshift({ title: 'homepage', path: 'homepage' })

            // Filter out any falsy entries (e.g., empty strings)
            crumbs = crumbs.filter(path => path)

            // Check for a special route param "k" to adjust last breadcrumb
            const paramK = this.route.params.k

            if (paramK) {
                const suffix = params.includes('nouveau') ? 'new' : (params.includes('formulaire') ? 'edit' : 'view')

                if (appSlug === 'voirie' || ['new', 'edit'].includes(suffix)) {
                    // Find and remove the crumb that directly matches the `k` param
                    const indexParam = crumbs.findIndex(crumb => crumb.title === String(paramK))
                    crumbs.splice(indexParam, 1)
                }
                if (appSlug !== 'voirie')
                    crumbs.at(-1).title = `${crumbs.at(1).title}.${suffix}`
            }

            return crumbs
        },

        // Computed property to get a clean path, stripping query params, trailing slashes, and hashes
        filterPath() {
            const path = this.route.path
            let fullPath = this.route.fullPath

            // If the path ends with '/', remove it (and the hash if present)
            if (path.endsWith('/')) {
                if (this.route.hash)
                    fullPath = fullPath.split('#')[0].slice(0, -1)
                else
                    fullPath = fullPath.slice(0, -1)
            }
            // If a hash is present (e.g., "#section1"), strip it
            else if (this.route.hash) {
                fullPath = fullPath.split('#')[0]
            }

            // If there are query params (e.g., ?id=5), strip them too
            if (Object.keys(this.route.query).length)
                return fullPath.split('?')[0]

            return fullPath
        },
    },
}
</script>

<template>
    <v-breadcrumbs :items="crumbs" class="pl-1 d-block" tag="ol">
        <template #prepend>
            <v-icon icon="mdi-home" size="small" class="pr-3" />
        </template>
        <template #title="{ item }">
            <NuxtLink :to="item.path === 'homepage' ? '/' : `${item.path}`">
                <span v-if="item.title" class="mr-3" v-html="$translate(item.title)" />
            </NuxtLink>
            <!-- href: 'breadcrumbs_dashboard',to redirect -->
        </template>
        <template #divider>
            <v-icon icon="mdi-chevron-right" />
        </template>
    </v-breadcrumbs>
</template>
